export class Ad
{
	constructor(store)
	{
		this.store = store
	}

	run()
	{
		if (this.store.data.service.Ad.enable) {
			this.store.service.Modal.target = "ad"
            this.store.service.Modal.show()
			this.store.service.Carousel.swipers["45f51f0e-208d-4e7a-9de0-1595989f6879"].autoplay.running = true
		}
	}
}
